import * as R from "ramda";
import {GenericSequenceType} from "../../../common/Constants";

export const constructDataDetailUnitKSU = (data) => {
    return data.filter(item => R.equals(item.saved, true)).map((item) => {
        return {
            kodeKsu: item.kodeKSU ? item.kodeKSU.value : null,
            total: Number(item.jumlah),
            kodeLocation: item.kodeLocation ? item.kodeLocation.value : null,
        }
    });
}

export const constructToQRReportKSU = (data) => {
    return data.filter(item => R.equals(item.saved, true)).map((item) => {
        return {
            itemName: item.namaKSU,
            qrCode: item.qrCodeEncrypted,
            qrCodeRaw: item.qrCode,
        }
    });
}

export const validateDataDetailUnitKSU = (list) => {
    const errors = [];

    const fieldsToValidate = ['kodeLocation', 'kodeKSU', 'jumlah'];

    list.forEach((obj, index) => {
        const objErrors = {};

        fieldsToValidate.forEach((field) => {
            const value = obj[field];
            if (value === null || value === undefined || value === '') {
                objErrors[field] = `${field} cannot be empty or null`;
            }
        });

        const jumlah = obj["jumlah"];
        if (!R.isNil(jumlah)) {
            if (jumlah < 1) {
                objErrors['jumlah'] = 'jumlah must be greather than 0';
            }
        }

        if (Object.keys(objErrors).length > 0) {
            errors.push({ index, errors: objErrors });
        }
    });

    return !errors.length > 0 && list.length > 0;
};

export const getSupplierExpOptions = (data) => {
    return data.map((item) => {
        return {
            value: item.supplierCode,
            label: item.supplierCode,
            name: item.supplierName,
        }
    })
}

export const constructGenSeqPayload = (kodeCabang) => {
    return {
        seqType: GenericSequenceType.RECEIVING_KSU,
        nosDealerCode: kodeCabang.value,
        transactionType: GenericSequenceType.RECEIVING_KSU,
    }
}